<template>
  <div class="flex flex-col md:flex-row h-screen">
    <!-- Citas con saldo pendiente -->
    <div
      class="md:w-1/4 w-full mt-8 bg-white p-4 rounded shadow h-full overflow-y-auto"
    >
      <h2 class="text-lg font-bold mb-4 flex items-center gap-2">
        <svg
          class="w-5 h-5 text-blue-600"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        Citas con saldo pendiente
      </h2>

      <div v-if="citasPendientes.length === 0" class="text-sm text-gray-500">
        No hay citas pendientes hoy
      </div>

      <div
        v-for="cita in citasPendientes"
        :key="cita.id"
        class="p-4 border rounded-lg mb-3 bg-gray-50 shadow-inner"
      >
        <p class="font-semibold truncate">
          {{ cita.pacienteNombre || "Cliente" }}
        </p>
        <p class="text-sm text-gray-600">
          Pendiente:
          <span class="text-red-500 font-bold"
            >${{ cita.balancePendiente.toFixed(2) }}</span
          >
        </p>
        <button
          class="mt-3 w-full bg-blue-600 hover:bg-blue-700 text-white py-1 rounded text-sm font-semibold shadow"
          @click="cobrarCitaPendiente(cita)"
        >
          Cobrar saldo
        </button>
      </div>
    </div>

    <!-- Categorías y productos -->
    <div class="md:w-2/4 w-full p-4 overflow-y-auto">
      <!-- Categorías -->
      <h2 class="text-xl font-bold mb-4 flex items-center gap-2">
        <svg
          class="w-6 h-6 text-purple-600"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M4 6h16M4 12h16M4 18h7"
          />
        </svg>
        Categorías
      </h2>

      <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 mb-6">
        <button
          v-for="cat in categorias"
          :key="cat.id"
          class="aspect-square flex items-center justify-center p-4 rounded-xl bg-white shadow border hover:bg-blue-50 text-center font-semibold transition text-sm"
          @click="seleccionarCategoria(cat.id)"
        >
          {{ cat.nombre }}
        </button>
      </div>

     <!-- Productos -->
<h2 class="text-xl font-bold mb-4 flex items-center gap-2">
  <svg
    class="w-6 h-6 text-amber-600"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M3 3h18v18H3V3z" />
  </svg>
  Productos
</h2>

<!-- Buscador -->
<div class="mb-4">
  <input
    type="text"
    v-model="filtroProducto"
    placeholder="Buscar productos..."
    class="w-full p-2 rounded border shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
  />
</div>

<!-- Grid de productos -->
<div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
  <div
    v-for="prod in productosFiltrados"
    :key="prod.id"
    class="group bg-white p-4 rounded-xl shadow hover:shadow-xl transition relative aspect-square flex flex-col justify-between"
  >
    <!-- Contenido de la tarjeta -->
    <div>
      <div class="text-lg font-bold text-gray-800 truncate">
        {{ prod.nombre }}
      </div>
      <div class="text-sm text-gray-500">
        ${{ prod.precio.toFixed(2) }}
      </div>
    </div>

    <!-- Botones de acción -->
<button
  class="self-end bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded-full text-sm font-semibold shadow mt-4"
  @click="manejarClickProducto(prod)"
>
  ➕ Agregar
</button>
<button
  class="mt-2 text-xs text-blue-600 hover:underline self-start"
  @click="abrirDetalleProducto(prod)"
>
  Ver detalles
</button>

<!-- Modal de selección de variante -->
<div
  v-if="productoSeleccionado && productoSeleccionado.variantes"
  class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4"
  @click.self="cerrarModalVariante"
>
  <div class="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full max-h-[85vh] overflow-y-auto">
    <div class="flex justify-between items-center mb-4">
      <h3 class="text-lg font-bold">Selecciona opciones</h3>
      <button class="text-gray-500 hover:text-gray-700" @click="cerrarModalVariante">✕</button>
    </div>

    <div v-for="(lista, attr) in variantesAgrupadasPOS" :key="attr" class="mb-3">
      <p class="text-sm font-semibold mb-2 capitalize">{{ attr }}</p>
      <div class="space-y-2 max-h-40 overflow-y-auto pr-1">
        <label
          v-for="v in lista"
          :key="v.id"
          class="p-3 border rounded mb-1 hover:bg-gray-100 cursor-pointer flex items-start space-x-2"
        >
          <input
            type="radio"
            class="mt-1"
            :name="`attr-${attr}`"
            :value="v.id"
            v-model="seleccionesPOS[attr]"
          />
          <div class="flex-1">
            <div class="font-semibold">{{ v.valor }}</div>
            <div class="text-sm text-gray-600">{{ v.descripcion }}</div>
            <div v-if="v.precio !== null && v.precio !== undefined" class="text-sm text-gray-800 mt-1">
              Precio: ${{ Number(v.precio).toFixed(2) }}
            </div>
          </div>
        </label>
      </div>
    </div>

    <button
      class="mt-4 w-full bg-green-600 text-white py-2 rounded font-semibold"
      @click="confirmarVarianteSeleccionada"
    >
      Agregar al carrito
    </button>
  </div>
</div>

    <!-- Tooltip estilizado -->
    <div
      class="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 
             px-2 py-1 bg-gray-800 text-white text-xs rounded
             opacity-0 group-hover:opacity-100 transition whitespace-nowrap"
    >
      {{ prod.nombre }}
    </div>
  </div>
</div>
    </div>
<!-- Modal de detalles del producto -->
<div
  v-if="productoDetalle"
  class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4"
  @click.self="cerrarDetalleProducto"
>
  <div class="bg-white p-6 rounded-lg shadow-lg max-w-md w-full space-y-3">
    <div class="flex items-center justify-between">
      <h3 class="text-lg font-bold text-gray-800">Detalles del producto</h3>
      <button
        class="text-gray-500 hover:text-gray-700"
        @click="cerrarDetalleProducto"
      >
        ✕
      </button>
    </div>
    <div class="space-y-2">
      <p class="text-xl font-semibold text-gray-900">
        {{ productoDetalle.nombre }}
      </p>
      <p class="text-sm text-gray-600 whitespace-pre-line">
        {{ productoDetalle.descripcion || "Sin descripción disponible." }}
      </p>
      <p class="text-base font-semibold text-blue-600">
        Precio base: ${{ Number(productoDetalle.precio || 0).toFixed(2) }}
      </p>
      <div class="text-sm text-gray-500 space-y-1">
        <p>
          Tipo:
          <span class="font-semibold capitalize">{{ productoDetalle.tipo || "producto" }}</span>
        </p>
        <p v-if="productoDetalle.usaVariantes">
          Variantes disponibles: sí
        </p>
        <p v-else>Variantes disponibles: no</p>
      </div>
    </div>
    <button
      class="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded font-semibold"
      @click="cerrarDetalleProducto"
    >
      Entendido
    </button>
  </div>
</div>


    <!-- Carrito -->
    <div
      class="md:w-1/4 w-full bg-white border-l p-6 flex flex-col justify-between shadow-inner h-full overflow-y-auto"
    >
      <div>
        <h2 class="text-xl font-bold mb-4 flex items-center gap-2">
          <svg
            class="w-6 h-6 text-gray-700"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 7M7 13l-1.6 8M17 13l1.6 8M9 21a1 1 0 100-2 1 1 0 000 2zm8 0a1 1 0 100-2 1 1 0 000 2z"
            />
          </svg>
          Carrito
        </h2>

        <div
          v-for="item in carrito"
          :key="item.cartKey || item.id"
          class="flex justify-between items-center mb-3 border-b pb-2 gap-3"
        >
          <div class="flex-1">
            <p class="font-semibold truncate">
              {{ item.nombre }}
              <span v-if="item.variante">- {{ item.variante }}</span>
            </p>

            <div class="text-sm text-gray-600 space-y-1">
              <div>
                <span class="font-semibold"
                  >${{ item.precio.toFixed(2) }} x {{ item.cantidad }}</span
                >
                <span>= ${{ (item.precio * item.cantidad).toFixed(2) }}</span>
              </div>
              <div class="flex flex-wrap items-center gap-2 text-xs">
                <label class="font-semibold">Desc:</label>
                <select
                  v-model="item.descuentoTipo"
                  class="border rounded px-1 py-0.5 text-xs"
                >
                  <option value="ninguno">N/A</option>
                  <option value="porcentaje">% Off</option>
                  <option value="fijo">$ Off</option>
                </select>
                <input
                  type="number"
                  min="0"
                  step="0.01"
                  class="border rounded px-1 py-0.5 w-20 text-right"
                  :disabled="item.descuentoTipo === 'ninguno'"
                  v-model.number="item.descuentoValor"
                />
                <span v-if="tieneDescuentoItem(item)" class="text-green-600">
                  (-${{ descuentoItem(item).toFixed(2) }})
                </span>
              </div>
              <div
                v-if="item.descuentoTipo !== 'ninguno'"
                class="flex flex-wrap items-center gap-2 text-xs"
              >
                <label class="font-semibold">Unidades:</label>
                <input
                  type="number"
                  min="1"
                  :max="item.cantidad"
                  v-model.number="item.descuentoCantidad"
                  class="border rounded px-1 py-0.5 w-16 text-right"
                />
                <span class="text-gray-500">de {{ item.cantidad }}</span>
              </div>
              <div class="text-sm">
                <strong>Total:</strong>
                ${{ totalLineaItem(item).toFixed(2) }}
              </div>
              <div>
                <span
                  v-if="item.tipo === 'servicio'"
                  class="text-green-600 text-xs"
                >
                  (servicio - 0% imp.)
                </span>
                <span
                  v-else-if="taxesLoaded && getRateFor(item, taxes.value) > 0"
                  class="text-blue-600 text-xs"
                >
                  (+${{
                    (
                      totalLineaItem(item) * getRateFor(item, taxes.value)
                    ).toFixed(2)
                  }}
                  imp. {{ (getRateFor(item, taxes.value) * 100).toFixed(0) }}%)
                </span>
              </div>
            </div>
          </div>

       <div class="flex items-center gap-2">
  <!-- Disminuir cantidad -->
  <button
    @click="disminuirCantidad(item)"
    class="bg-gray-300 px-2 rounded text-sm"
    title="Disminuir"
  >
    <Minus class="w-4 h-4 text-gray-800" />
  </button>

  <!-- Mostrar cantidad -->
  <span class="w-6 text-center">{{ item.cantidad }}</span>

  <!-- Aumentar cantidad -->
  <button
    @click="aumentarCantidad(item)"
    class="bg-gray-300 px-2 rounded text-sm"
    title="Aumentar"
  >
    <Plus class="w-4 h-4 text-gray-800" />
  </button>

  <!-- Convertir en certificado -->
  <button
    @click="abrirModalCertificadoParaProducto(item)"
    class="bg-blue-100 px-2 rounded text-sm"
    title="Marcar como certificado de regalo"
  >
    <Gift class="w-4 h-4 text-blue-600" />
  </button>

  <!-- Eliminar del carrito -->
  <button
    @click="eliminarDelCarrito(item)"
    class="bg-red-500 text-white px-2 rounded text-sm"
    title="Eliminar"
  >
    <Trash2 class="w-4 h-4" />
  </button>
</div>

        </div>
      </div>
     

      <div class="mt-6">
        <!-- Totales -->
        <div class="text-sm">
          Subtotal: <strong>${{ subtotal.toFixed(2) }}</strong>
        </div>
        <div class="text-sm">
          Impuestos: <strong>${{ impuestos.toFixed(2) }}</strong>
        </div>
        <div class="text-xl font-bold mt-1">
          Total a pagar: ${{ total.toFixed(2) }}
        </div>

     <!-- Método de pago principal -->
<div class="mt-4">
  <label class="block mb-2 font-medium">Método de pago</label>
  <select
    v-model="metodoPago"
    @change="limpiarMonto"
    class="w-full p-2 rounded border"
  >
    <option value="efectivo">Efectivo</option>
    <option value="tarjeta">Tarjeta</option>
    <option value="ATH Movil">ATH Movil</option>
  </select>
</div>

<!-- Campo de monto dinámico (para todos los métodos) -->
<transition name="fade" mode="out-in">
  <div
    v-if="['efectivo', 'tarjeta', 'ATH Movil'].includes(metodoPago)"
    class="mt-4 space-y-3"
    :key="metodoPago"
  >
    <label class="block font-medium">
      Monto recibido con {{ metodoPago }}
    </label>

    <!-- Botones rápidos solo si es efectivo -->
    <div
      v-if="metodoPago === 'efectivo'"
      class="grid grid-cols-4 gap-2"
    >
      <button
        v-for="monto in [5, 10, 15, 20, 30, 40, 50]"
        :key="monto"
        type="button"
        @click="montoRecibido = monto"
        class="bg-blue-100 hover:bg-blue-200 text-blue-800 font-semibold py-2 rounded transition text-sm"
      >
        ${{ monto.toFixed(2) }}
      </button>
    </div>

    <!-- Entrada manual -->
    <div class="relative">
      <span
        class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 font-bold text-lg"
        >$</span>
      <input
        type="number"
        inputmode="decimal"
        min="0"
        step="0.01"
        v-model.number="montoRecibido"
        :key="resetKey"
        class="w-full p-2 pl-7 rounded border text-right font-semibold"
        placeholder="Ej: 50.00"
      />
    </div>
  </div>
</transition>

<!-- Descuento -->
<div class="text-sm mt-4">
  <label class="block font-medium mb-1">Descuento</label>
  <div class="flex gap-2 items-center">
    <select v-model="descuento.tipo" class="p-2 border rounded text-sm">
      <option value="porcentaje">%</option>
      <option value="fijo">$/fijo</option>
    </select>
    <input
      type="number"
      min="0"
      step="0.01"
      v-model.number="descuento.valor"
      class="p-2 border rounded w-full text-right"
      placeholder="0.00"
    />
  </div>
</div>
<!-- Botón abrir modal certificado de regalo -->
<GiftCertificateModal
  :isOpen="isCertificadoModalOpen"
  :datosIniciales="certificadoTemporal"
  @close="isCertificadoModalOpen = false"
  @certificadoCreado="handleCertificadoCreado"
/>


<button
  type="button"
  @click="agregarCertificadoManual"
  class="flex items-center gap-2 rounded-md bg-white text-gray-800 border border-gray-300 hover:bg-gray-100 px-4 py-2 shadow-sm transition focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1"
>
  <Gift class="w-5 h-5 stroke-[1.5]" />
  <span class="text-sm font-medium">Generar Certificado de Regalo</span>
</button>


<QrScanner
  v-if="mostrarModalScanner"
  @close="mostrarModalScanner = false"
  @certificadoAplicado="aplicarCertificado"
/>

<button
  type="button"
  @click="mostrarModalScanner = true"
  class="flex items-center gap-2 rounded-md bg-white text-gray-800 border border-gray-300 hover:bg-gray-100 px-4 py-2 shadow-sm transition focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1"
>
  <QrCode class="w-5 h-5 stroke-[1.5]" />
  <span class="text-sm font-medium">Escanear Certificado</span>
</button>


<!-- 🔄 Métodos de pago mixtos (solo si hace falta) -->
<div
  v-if="totalPagado < total"
  class="mt-6 border-t pt-4"
>
  <label class="block mb-2 font-medium">Métodos de pago mixtos (opcional)</label>

  <div
    v-for="(pago, index) in metodosDePago"
    :key="index"
    class="flex items-center gap-2 mb-2"
  >
    <select v-model="pago.metodo" class="w-1/2 p-2 rounded border">
      <option disabled value="">Seleccionar método</option>
      <option value="efectivo">Efectivo</option>
      <option value="tarjeta">Tarjeta</option>
      <option value="ATH Movil">ATH Movil</option>
    </select>

    <input
      type="number"
      min="0"
      step="0.01"
      v-model.number="pago.monto"
      class="w-1/2 p-2 rounded border text-right"
      placeholder="$0.00"
    />

    <button
      type="button"
      @click="eliminarMetodo(index)"
      class="text-red-500 font-bold"
      title="Eliminar"
    >
      ✕
    </button>
  </div>

  <button
    type="button"
    @click="agregarMetodo"
    class="bg-blue-100 hover:bg-blue-200 text-blue-800 font-semibold px-3 py-1 rounded text-sm"
  >
    + Añadir método
  </button>

  <div class="text-sm text-gray-600 mt-2">
    Total en pagos mixtos: <strong>${{ totalPagado.toFixed(2) }}</strong>
    <div v-if="totalPagado < total" class="text-red-600 font-semibold">
      Faltan: ${{ (total - totalPagado).toFixed(2) }}
    </div>
    <div v-else-if="totalPagado > total" class="text-green-600 font-semibold">
      Cambio a devolver: ${{ (totalPagado - total).toFixed(2) }}
    </div>
  </div>
</div>

<!-- Correo del cliente -->
<div class="mt-4">
  <label class="block mb-2 font-medium">Correo del cliente</label>
  <input
    type="email"
    v-model="emailCliente"
    class="w-full p-2 rounded border"
    placeholder="cliente@correo.com"
  />
</div>

<!-- Finalizar venta -->
<button
  class="mt-6 w-full bg-green-600 text-white py-2 rounded font-bold hover:bg-green-700 transition"
  :disabled="!hayPagoValido"
  @click="finalizarVenta"
>
  Finalizar venta
</button>

      </div>
    </div>
  </div>
  
</template>

<script setup>
/* eslint-disable no-undef, no-unused-vars */
import { ref, computed, onMounted } from "vue";
import { db } from "@/firebase";
import {
  collection,
  getDocs,
  query,
  where,
  addDoc,
  updateDoc,
  setDoc, 
  doc,
  Timestamp,
  onSnapshot,
} from "firebase/firestore";
import { generarPDFVentaBase64 } from "@/utils/reciboPdf";
import { getFunctions, httpsCallable, } from "firebase/functions";
import GiftCertificateModal from "@/components/pos/GiftCertificateModal.vue"
import { Gift, Minus, Plus, Trash2, QrCode} from "lucide-vue-next";
import { crearCertificado, enviarCorreoCertificado } from "@/utils/certificados";
import { generarPDFCertificadoBase64 } from "@/utils/pdfCertificado";
import QrScanner from "@/components/pos/QrScanner.vue"

const productoSeleccionadoParaCertificado = ref(null);
const isCertificadoModalOpen = ref(false);
const certificadoTemporal = ref(null); 
const mostrarModalScanner = ref(false);
const seleccionesPOS = ref({});

const confirmarVarianteSeleccionada = () => {
  const base = productoSeleccionado.value;
  const variantes = Array.isArray(base?.variantes) ? base.variantes : [];
  if (!base || !variantes.length) return;

  // Agrupar por atributo y validar selección completa
  const agrupadas = variantes.reduce((acc, v) => {
    const attr = v.atributo || base.atributoPrincipal || "Variante";
    if (!acc[attr]) acc[attr] = [];
    acc[attr].push(v);
    return acc;
  }, {});

  const selecciones = [];
  for (const [attr, lista] of Object.entries(agrupadas)) {
    const selId = seleccionesPOS.value[attr];
    const variante = lista.find((v) => v.id === selId) || lista.find((v) => v.valor === selId);
    if (!variante) {
      alert(`Selecciona ${attr}`);
      return;
    }
    selecciones.push({ atributo: attr, variante });
  }

  const varianteConPrecio = selecciones.find((s) => typeof s.variante.precio === "number");
  const precioFinal =
    typeof varianteConPrecio?.variante.precio === "number"
      ? varianteConPrecio.variante.precio
      : base.precio;

  const keyParts = selecciones.map((s) => `${s.atributo}:${s.variante.id || s.variante.valor || ""}`).join("_");
  const cartKey = `${base.id}_${keyParts}`;

  const productoFinal = {
    id: base.id,
    nombre: base.nombre,
    variante: selecciones.map((s) => `${s.atributo}: ${s.variante.valor || s.variante.id || ""}`).join(" / "),
    selecciones: selecciones.map((s) => ({ atributo: s.atributo, valor: s.variante.valor || "" })),
    precio: precioFinal,
    cantidad: 1,
    tipo: base.tipo || "producto",
    impuesto: base.impuesto || 0,
    taxId: base.taxId || null,
    taxIds: Array.isArray(base.taxIds) ? [...base.taxIds] : base.taxId ? [base.taxId] : [],
    exento: base.exento || false,
    cartKey,
  };

  agregarProducto(productoFinal);
  productoSeleccionado.value = null;
  seleccionesPOS.value = {};
};



const manejarClickProducto = async (producto) => {
  if (producto.usaVariantes) {
    const snap = await getDocs(collection(db, `productos/${producto.id}/variantes`));
    const variantes = snap.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));

    if (!variantes.length) {
      alert("Este producto tiene variantes, pero no se encontraron disponibles.");
      return;
    }

    // Aquí solo asignas para abrir el modal
    productoSeleccionado.value = {
      ...producto,
      variantes
    };
    seleccionesPOS.value = {};
  } else {
    agregarProducto(producto);
  }
};

const cerrarModalVariante = () => {
  productoSeleccionado.value = null;
  seleccionesPOS.value = {};
};

const abrirDetalleProducto = (producto) => {
  productoDetalle.value = producto;
};

const cerrarDetalleProducto = () => {
  productoDetalle.value = null;
};

const variantesAgrupadasPOS = computed(() => {
  const variantes = Array.isArray(productoSeleccionado.value?.variantes) ? productoSeleccionado.value.variantes : [];
  const grouped = {};
  for (const v of variantes) {
    const attr = v.atributo || productoSeleccionado.value?.atributoPrincipal || "Variante";
    if (!grouped[attr]) grouped[attr] = [];
    grouped[attr].push(v);
  }
  return grouped;
});

const handleCertificadoCreado = (certificado) => {
  console.log("🧾 Certificado recibido:", certificado);

  const index = carrito.value.findIndex(
    (p) => p.id === productoSeleccionadoParaCertificado.value?.id
  );

  if (index === -1) {
    console.warn("❌ No se encontró el certificado en el carrito.");
    return;
  }

  const producto = carrito.value[index];

  carrito.value[index] = {
    ...producto,
    precio: certificado.monto > 0 ? certificado.monto : producto.precio,
    esCertificado: true,
    datosCertificado: {
      destinatarioNombre: certificado.destinatarioNombre,
      destinatarioEmail: certificado.destinatarioEmail,
      mensaje: certificado.mensaje,
      remitente: certificado.remitenteNombre || "",
      uuid: certificado.uuid || null,
      certificadoId: certificado.id || null,
      tipo: producto.tipo || "monto",
      descripcion: producto.nombre || "Certificado de regalo",
      productoId: producto.id || null,
    },
  };
  normalizarDescuentoItem(carrito.value[index]);

  isCertificadoModalOpen.value = false;
  productoSeleccionadoParaCertificado.value = null;
};



const abrirModalCertificadoParaProducto = (producto) => {
  productoSeleccionadoParaCertificado.value = producto;

  certificadoTemporal.value = {
    monto: producto.precio || 0,
    mensaje: "",
  };

  isCertificadoModalOpen.value = true;
};

const agregarCertificadoManual = () => {
  const id = `cert_manual_${Date.now()}`;

  const certificado = {
    id,
    nombre: "Certificado de Regalo",
    precio: 0, // Lo defines al generar el certificado
    cantidad: 1,
    tipo: "certificado",
    esCertificado: true,
    datosCertificado: null, // Se llenará desde el modal
  };

  const certificadoCarrito = prepararProductoParaCarrito(certificado);
  carrito.value.push(certificadoCarrito);

  productoSeleccionadoParaCertificado.value = certificadoCarrito;

  certificadoTemporal.value = {
    monto: 0,
    mensaje: "",
  };

  isCertificadoModalOpen.value = true;
};

const aplicarCertificado = (cert) => {
  carrito.value.push(prepararProductoParaCarrito({
    id: `cert_${cert.uuid}`,
    nombre: cert.descripcion || "Certificado Redimido",
    tipo: "certificado",
    cantidad: 1,
    precio: -Math.abs(cert.monto),
    datosCertificado: cert,
  }));
};


const toRateDecimal = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? (n <= 1 ? n : n / 100) : 0;
};
const isExento = (v) => v === true || v === "true" || v === 1 || v === "1";
const getRateFor = (p, taxes) => {
  if (!p || isExento(p.exento)) return 0;
  // Los servicios NO tienen impuestos aplicados
  if (p.tipo === "servicio") return 0;

  // Verificar que taxes esté definido y no sea vacío
  if (!taxes || typeof taxes !== "object") {
    console.warn("getRateFor: taxes is not defined or not an object", taxes);
    return 0;
  }

  const ids =
    Array.isArray(p.taxIds) && p.taxIds.length
      ? p.taxIds
      : p.taxId
      ? [p.taxId]
      : [];

  // Agregar más validación para evitar el error
  if (!ids || ids.length === 0) return toRateDecimal(p.impuesto ?? p.tax) || 0;

  // Debug: mostrar los IDs de impuestos que está buscando
  console.log(
    "getRateFor: buscando taxIds",
    ids,
    "en taxes disponibles:",
    Object.keys(taxes)
  );

  const fromIds = (ids || [])
    .filter((id) => {
      if (!id) return false;
      const taxInfo = taxes[id];
      if (!taxInfo) {
        console.warn(
          `getRateFor: tax ID ${id} no encontrado en la colección de impuestos`
        );
        return false;
      }
      return taxInfo.activo !== false;
    })
    .reduce((acc, id) => {
      const taxInfo = taxes[id];
      const porcentaje = taxInfo?.porcentaje || 0;
      return acc + toRateDecimal(porcentaje);
    }, 0);

  if (fromIds > 0) return fromIds;
  return toRateDecimal(p.impuesto ?? p.tax) || 0;
};

// Refs


const montoRecibido = ref(null);
const resetKey = ref(0);
const metodosDePago = ref([]); // empieza vacío
const agregarMetodo = () => {
  metodosDePago.value.push({ metodo: '', monto: 0 });
};
const eliminarMetodo = (index) => {
  metodosDePago.value.splice(index, 1);
};
const totalPagado = computed(() => {
  const principal = Number(montoRecibido.value) || 0;
  const adicionales = metodosDePago.value.reduce(
    (acc, pago) => acc + (Number(pago.monto) || 0),
    0
  );
  return principal + adicionales;
});


// Usa solo esta:



const categorias = ref([]);
const productos = ref([]);
const carrito = ref([]);

const prepararProductoParaCarrito = (producto = {}) => {
  const cantidad = Number(producto.cantidad) || 1;
  return {
    ...producto,
    cantidad,
    descuentoTipo: producto.descuentoTipo || "ninguno",
    descuentoValor: Number(producto.descuentoValor) || 0,
    descuentoCantidad:
      Number(producto.descuentoCantidad) || Number(producto.cantidad) || 1,
    cartKey: producto.cartKey || producto.id,
  };
};

const normalizarDescuentoItem = (item) => {
  if (!item) return;
  if (!item.descuentoTipo) item.descuentoTipo = "ninguno";
  if (item.descuentoValor === undefined || item.descuentoValor === null)
    item.descuentoValor = 0;
  const cantidad = Number(item.cantidad) || 1;
  if (!item.descuentoCantidad || item.descuentoCantidad > cantidad) {
    item.descuentoCantidad = cantidad;
  }
  if (item.descuentoCantidad < 1) item.descuentoCantidad = 1;
};

const descuentoItem = (item) => {
  if (!item) return 0;
  normalizarDescuentoItem(item);
  if (item.descuentoTipo === "ninguno") return 0;

  const qtyAplicada = Math.min(
    Number(item.descuentoCantidad) || 0,
    Number(item.cantidad) || 0
  );
  const baseAplicado = (Number(item.precio) || 0) * qtyAplicada;
  const valor = Number(item.descuentoValor) || 0;

  if (!valor || baseAplicado <= 0 || qtyAplicada <= 0) return 0;

  if (item.descuentoTipo === "porcentaje") {
    return Math.min(baseAplicado, baseAplicado * (valor / 100));
  }

  if (item.descuentoTipo === "fijo") {
    return Math.min(baseAplicado, valor);
  }

  return 0;
};

const totalLineaItem = (item) => {
  if (!item) return 0;
  const base = (Number(item.precio) || 0) * (Number(item.cantidad) || 0);
  return Math.max(0, base - descuentoItem(item));
};

const tieneDescuentoItem = (item) => descuentoItem(item) > 0;
const metodoPago = ref("efectivo");
const categoriaSeleccionada = ref(null);
const emailCliente = ref("");
const citasPendientes = ref([]);
const taxes = ref({});
const taxesLoaded = ref(false);
const filtroProducto = ref("");
const productoSeleccionado = ref(null);
const productoDetalle = ref(null);



// 💰 Subtotal
const subtotal = computed(() =>
  carrito.value.reduce((sum, item) => sum + totalLineaItem(item), 0)
);

// 🔍 Filtro de productos
const productosFiltrados = computed(() => {
  const filtro = filtroProducto.value.toLowerCase();
  return productos.value.filter((p) =>
    p.nombre.toLowerCase().includes(filtro)
  );
});

// 🎯 Descuento seleccionado por el usuario
const descuento = ref({
  tipo: "porcentaje", // o "fijo"
  valor: 0
});

// 🔢 Cálculo del descuento en base al subtotal
const descuentoCalculado = computed(() => {
  const valor = Number(descuento.value.valor);
  if (!valor || valor <= 0) return 0;

  if (descuento.value.tipo === "porcentaje") {
    return subtotal.value * (valor / 100);
  } else {
    return Math.min(valor, subtotal.value); // evita negativo
  }
});

// 🧾 Impuestos (esto ya lo tienes más abajo, no se repite aquí)

// 🧮 Total final: subtotal - descuento + impuestos
const total = computed(() => {
  return subtotal.value - descuentoCalculado.value + impuestos.value;
});


// Cargar categorías
onMounted(async () => {
  const snap = await getDocs(collection(db, "categorias"));
  categorias.value = snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

  // Cargar impuestos primero
  onSnapshot(collection(db, "impuestos"), (snap) => {
    taxes.value = Object.fromEntries(snap.docs.map((d) => [d.id, d.data()]));
    taxesLoaded.value = true;
    console.log("Impuestos cargados:", Object.keys(taxes.value));
  });

  await cargarCitasPendientes();
});

// Seleccionar categoría
const seleccionarCategoria = async (categoriaId) => {
  categoriaSeleccionada.value = categoriaId;
  const q = query(
    collection(db, "productos"),
    where("categoria", "==", categoriaId)
  );
  const snap = await getDocs(q);
  productos.value = snap.docs
    .map((doc) => {
      const data = doc.data();
      const mostrarEn = (data.mostrarEn || "").toLowerCase();

      return {
        id: doc.id,
        ...data,
        nombre: data.nombre || "Sin nombre",
        precio: typeof data.precio === "number" ? data.precio : 0,
        imagenUrl: data.imagenUrl || "",
        mostrarEn,
        activo: data.activo ?? true,
      };
    })
    .filter((p) => {
      return (
        p.activo !== false && // el producto debe estar activo
        (p.mostrarEn === "pos" || p.mostrarEn === "ambos") // debe estar disponible en POS
      );
    });
};
// ✅ Pago válido cuando el total ya está cubierto (por principal o mixtos)
const hayPagoValido = computed(() => {
  return totalPagado.value >= total.value;
});


// Carrito
const agregarProducto = (producto) => {
  const index = carrito.value.findIndex(
    (p) => (p.cartKey || p.id) === (producto.cartKey || producto.id)
  );
  if (index !== -1) {
    carrito.value[index].cantidad++;
    normalizarDescuentoItem(carrito.value[index]);
  } else {
    carrito.value.push(prepararProductoParaCarrito(producto));
  }
};

const impuestos = computed(() =>
  carrito.value.reduce((totalImp, p) => {
    if (p.tipo === "servicio") return totalImp;
    if (!taxes.value || typeof taxes.value !== "object") return totalImp;

    const ids = Array.isArray(p.taxIds) ? p.taxIds : p.taxId ? [p.taxId] : [];

    const pct = ids
      .filter((id) => id && taxes.value[id] && taxes.value[id].activo !== false)
      .reduce((a, id) => a + (+taxes.value[id]?.porcentaje || 0), 0);

    return totalImp + totalLineaItem(p) * (pct / 100);
  }, 0)
);

const aumentarCantidad = (producto) => {
  if (producto) {
    producto.cantidad++;
    normalizarDescuentoItem(producto);
  }
};

const disminuirCantidad = (producto) => {
  if (producto && producto.cantidad > 1) {
    producto.cantidad--;
    normalizarDescuentoItem(producto);
  } else if (producto) eliminarDelCarrito(producto);
};

const eliminarDelCarrito = (itemOrId) => {
  const key =
    typeof itemOrId === "object"
      ? itemOrId.cartKey || itemOrId.id
      : itemOrId;
  carrito.value = carrito.value.filter(
    (p) => (p.cartKey || p.id) !== key
  );
};
const limpiarMonto = () => {
  montoRecibido.value = null;
};

// limpiar al finalizar
montoRecibido.value = null;

const cobrarCitaPendiente = (cita) => {
  if (!cita || !cita.balancePendiente || !cita.paciente) {
    alert("Cita inválida.");
    return;
  }

  const deposito = {
    id: "cita_" + cita.id,
    nombre: `Saldo pendiente: ${cita.paciente.nombre} ${
      cita.paciente.apellido || ""
    }`,
    precio: parseFloat(cita.balancePendiente),
    cantidad: 1,
    tipo: "servicio",
  };

  carrito.value.push(prepararProductoParaCarrito(deposito));
  emailCliente.value = cita.paciente.email || "";
};

const cargarCitasPendientes = async () => {
  const hoy = new Date().toISOString().split("T")[0];
  console.log("📅 Fecha de hoy:", hoy);

  const citasRef = collection(db, "citasGlobales");
  const q = query(
    citasRef,
    where("estado", "==", "confirmada"),
    where("fecha", "==", hoy),
    where("balancePendiente", ">", 0)
  );

  const snap = await getDocs(q);
  console.log("🟡 Total docs encontrados:", snap.size);

  citasPendientes.value = snap.docs.map((doc) => {
    const data = doc.data();
    return {
      id: doc.id,
      pacienteNombre: `${data.paciente?.nombre || ""} ${
        data.paciente?.apellido || ""
      }`,
      ...data,
    };
  });
};

const finalizarVenta = async () => {
  console.log("🔁 Iniciando proceso de venta");

  try {
    if (carrito.value.length === 0) {
      console.warn("🚫 Carrito vacío");
      alert("Carrito vacío");
      return;
    }

    if (!emailCliente.value) {
      console.warn("🚫 Email del cliente no ingresado");
      alert("Por favor ingrese el correo del cliente");
      return;
    }

    // Verificar pagos ingresados
    const montoRecibidoValido = Number(montoRecibido.value) > 0
      ? Number(montoRecibido.value)
      : 0;

    const montoMixto = metodosDePago.value.reduce(
      (acc, item) => acc + (Number(item.monto) || 0),
      0
    );

    const totalPagadoFinal = montoRecibidoValido + montoMixto;

    console.log("💵 Detalles de pago:", {
      montoRecibidoValido,
      montoMixto,
      totalPagadoFinal,
      totalVenta: total.value
    });

    if (totalPagadoFinal <= 0) {
      console.warn("🚫 Total pagado <= 0");
      alert("Debe ingresar al menos un método de pago con monto mayor a 0.");
      return;
    }

    if (totalPagadoFinal < total.value) {
      const confirmar = confirm(
        `El total pagado ($${totalPagadoFinal.toFixed(
          2
        )}) es menor al total de la venta ($${total.value.toFixed(
          2
        )}). ¿Deseas continuar con balance pendiente?`
      );
      if (!confirmar) {
        console.warn("🚫 Usuario canceló venta con pago incompleto");
        return;
      }
    }

    // Log del cálculo final antes de procesar venta
    console.log("📊 Cálculo total:", {
      subtotal: subtotal.value,
      descuento: descuentoCalculado.value,
      impuestos: impuestos.value,
      total: total.value,
      metodoPago: metodoPago.value,
      metodosDePago: metodosDePago.value
    });

    const venta = {
  productos: carrito.value
    .filter((p) => p && p.nombre)
    .map((p) => ({
      id: p.id || "",
      nombre: p.nombre || "Producto sin nombre",
      cantidad: Number(p.cantidad) || 1,
      precio: Number(p.precio) || 0,
      impuesto: getRateFor(p, taxes.value) || 0,
      tipo: p.tipo || "producto",
      descuentoTipo: p.descuentoTipo || "ninguno",
      descuentoValor: Number(p.descuentoValor) || 0,
      descuentoCantidad: Number(p.descuentoCantidad) || Number(p.cantidad) || 1,
      totalLinea: Number(totalLineaItem(p).toFixed(2)),
    })),
  subtotal: Number(subtotal.value.toFixed(2)) || 0,
  descuento: Number(descuentoCalculado.value.toFixed(2)) || 0, // ✅ requerido para evitar error
  impuestos: Number(impuestos.value.toFixed(2)) || 0,
  total: Number((subtotal.value - descuentoCalculado.value + impuestos.value).toFixed(2)) || 0,
  metodoPago: metodoPago.value || "mixto",
  metodosDePago: metodosDePago.value.filter(p => p.monto > 0),
  balancePendiente: Math.max(0, total.value - totalPagadoFinal),
  fecha: Timestamp.now(),
  origen: "pos",
  email: emailCliente.value || "",
};

    console.log("📝 Venta a registrar:", venta);

    // Marcar cita como pagada si aplica
    const saldoCita = carrito.value.find((item) =>
      String(item.id || "").startsWith("cita_")
    );
    if (saldoCita) {
      const citaId = String(saldoCita.id).replace("cita_", "");
      await updateDoc(doc(db, "citasGlobales", citaId), {
        balancePendiente: 0,
        pagada: true,
      });
      console.log("✅ Cita marcada como pagada:", citaId);
    }

    // Guardar venta en Firestore
// Guardar venta en Firestore
const docRef = await addDoc(collection(db, "ventas"), venta);
const ventaId = docRef.id;
console.log("✅ Venta guardada con ID:", ventaId);

// 🔻 Procesar certificados (si hay)
const certificados = carrito.value.filter((p) => p.esCertificado && p.datosCertificado);

for (const cert of certificados) {
  const datos = {
    ventaId,
    tipo: cert.datosCertificado.tipo || "monto",
    descripcion:
      cert.datosCertificado.descripcion ||
      cert.nombre ||
      "Certificado de regalo",
    valor: cert.precio || 0,
    destinatario: {
      nombre: cert.datosCertificado.destinatarioNombre || "",
      email: cert.datosCertificado.destinatarioEmail || ""
    },
    expiracionDias: 90
  };

  try {
    const certGenerado = await crearCertificado(datos);
    const uuid = certGenerado.id;

    const datosCorreo = {
      uuid,
      monto: datos.valor,
      descripcion: datos.descripcion,
      destinatarioNombre: datos.destinatario.nombre,
      destinatarioEmail: datos.destinatario.email,
      destinatario: {
        nombre: datos.destinatario.nombre,
        email: datos.destinatario.email,
      },
      mensaje: cert.datosCertificado.mensaje || "",
      remitenteNombre: cert.datosCertificado.remitente || "",
      tipo: datos.tipo,
      valor: datos.valor,
      expiracion: certGenerado.expiracion?.toDate?.()
        ? certGenerado.expiracion.toDate()
        : undefined,
    };

    const pdfBase64 = await generarPDFCertificadoBase64(datosCorreo);
    await enviarCorreoCertificado(datosCorreo, pdfBase64);

    console.log(`📨 Certificado enviado a: ${datosCorreo.destinatarioEmail}`);
  } catch (e) {
    console.error("❌ Error al procesar certificado:", datos, e);
    alert(`El certificado para ${datos.destinatario.email} no se pudo enviar correctamente.`);
  }
}

// 🔻 Generar PDF del recibo para el cliente
let base64;
try {
  base64 = await generarPDFVentaBase64({
    ...venta,
    id: ventaId,
    tienda: {
      nombre: "NAT Spa Wellness Center",
      direccion: "Calle Betance #56",
      telefono: "(787) 415-9799",
      email: "natspawellnesscenter@yahoo.com",
    },
  });
  console.log("📄 PDF generado correctamente");
} catch (e) {
  console.error("❌ Error al generar PDF:", e);
  alert("No se pudo generar el recibo en PDF.");
  return;
}

// 🔻 Enviar recibo por correo al cliente
try {
  const sendEmail = httpsCallable(getFunctions(), "enviarCorreoGenerico");
  await sendEmail({
    to: venta.email,
    subject: "Tu recibo de compra - Nat Spa Wellness Center",
    html: `
      <div style="font-family: sans-serif; color: #0f172a; padding: 1rem;">
        <h2 style="margin-bottom: 0.5rem;">Gracias por su compra</h2>
        <p style="margin: 0;">Adjuntamos su recibo de compra en formato PDF.</p>
        <p style="margin-top: 1rem;">Esperamos verlo pronto.</p>
      </div>
    `,
    pdfBase64: base64,
    fileName: `recibo_${ventaId}.pdf`,
  });
  console.log("📧 Email enviado correctamente a:", venta.email);
} catch (e) {
  console.error("❌ Error al enviar email:", e);
  alert("La venta fue registrada pero no se pudo enviar el recibo.");
}


    // Guardar recibo en perfil de paciente (si aplica)
    try {
      const emailNormalizado = venta.email.trim().toLowerCase();
      const pacienteQuery = query(
        collection(db, "pacientes"),
        where("emailLower", "==", emailNormalizado)
      );
      const pacienteSnap = await getDocs(pacienteQuery);

      if (!pacienteSnap.empty) {
        const pacienteDoc = pacienteSnap.docs[0];
        const pacienteId = pacienteDoc.id;

        await setDoc(doc(db, "pacientes", pacienteId, "recibos", ventaId), {
          ...venta,
          id: ventaId,
          timestamp: Timestamp.now(),
        });

        console.log("🧾 Recibo guardado en perfil del paciente:", pacienteId);
      } else {
        console.warn("⚠️ No se encontró paciente con ese email");
      }
    } catch (e) {
      console.error("❌ Error al guardar recibo en paciente:", e);
    }

    // Reset UI
    alert("Venta registrada y recibo enviado correctamente");
    carrito.value = [];
    metodoPago.value = "efectivo";
    emailCliente.value = "";
    metodosDePago.value = [];
    montoRecibido.value = null;
    resetKey.value++;
    await cargarCitasPendientes();
  } catch (error) {
    console.error("❌ Error general al finalizar la venta:", error);
    alert("Hubo un problema al registrar o enviar el recibo.");
  }
};


</script>
